import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export function getMatchHubMatchInfoCardStyles(theme: Theme) {
  return StyleSheet.create({
    sectionCardDense: {
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.md,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: theme.spacing.sm,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
    },
    rowLast: {
      borderBottomWidth: 0,
    },
    iconWrap: {
      width: 32,
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: theme.spacing.sm,
    },
    flagWrap: {
      width: 32,
      height: 22,
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: theme.spacing.sm,
    },
    textCol: {
      flex: 1,
      minWidth: 0,
    },
    primary: {
      ...theme.typography.labelSmall,
      fontWeight: '600',
      color: theme.gray[900],
    },
    secondary: {
      ...theme.typography.caption,
      fontSize: 12,
      lineHeight: 16,
      color: theme.gray[500],
      marginTop: 1,
    },
  });
}
